import React, { PropTypes } from 'react';
import Status from './StatusComponent';
import { Common } from '../../../../constants/ManageApps';
import { SAVE_LEVEL } from '../../../../constants/Level';

const InContextBetaSection = ({ inContextBeta, parentInContextBeta, level, isDisabled, setValue }) => {
    const normalizedStatus =
        typeof inContextBeta === 'boolean'
            ? inContextBeta
                ? Common.active.key
                : Common.inactive.key
            : undefined;
    const normalizedParentStatus = parentInContextBeta ? Common.active.key : Common.inactive.key;

    return (
        <section className="content-section">
            <Status
                isDisabled={isDisabled}
                objectName="inContextBeta"
                value={normalizedStatus}
                parentValue={normalizedParentStatus}
                level={level}
                setValue={(key, value) => {
                    if (value === Common.inherit.key) {
                        setValue('inContextBeta', undefined);
                        return;
                    }

                    setValue('inContextBeta', value === Common.active.key);
                }}
            />
        </section>
    );
};

InContextBetaSection.propTypes = {
    inContextBeta: PropTypes.bool,
    parentInContextBeta: PropTypes.bool,
    level: PropTypes.string,
    isDisabled: PropTypes.bool,
    setValue: PropTypes.func.isRequired
};

InContextBetaSection.defaultProps = {
    parentInContextBeta: false,
    level: SAVE_LEVEL.CHAIN,
    isDisabled: false
};

export default InContextBetaSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/InContextBetaSection.js